export default __webpack_public_path__ + "img/blank-checkobox.b06da8af.svg";